import React from 'react';
import { Flex } from 'glints-aries/es';
import { Icon, Typography } from 'glints-aries/es/@next';
import { Neutral } from 'glints-aries/es/@next/utilities/colors';
import { space8 } from 'glints-aries/es/@next/utilities/spacing';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const Button = styled.button`
  width: 100%;
  padding: ${space8};
  border: 0;
  background: transparent;
  text-align: left;
  cursor: pointer;
`;

export type RoleSwitchMenuItemProps = {
  onClick: () => void;
};

export default function RoleSwitchMenuItem({
  onClick,
}: RoleSwitchMenuItemProps) {
  return (
    <Button
      type="button"
      onClick={onClick}
      data-glints-tracking-element-name="switch_role_to_jobseeker"
    >
      <Flex alignItems="center" style={{ gap: space8 }}>
        <Icon
          name="ri-user-switch-line"
          fill={Neutral.B40}
          width={24}
          height={24}
        />
        <Typography variant="body1" color={Neutral.B18} as="span">
          <FormattedMessage
            id="interactive-switch-role-to-jobseeker"
            defaultMessage="Switch Role to Job Seeker"
          />
        </Typography>
      </Flex>
    </Button>
  );
}
